import type { NavigationGuard } from "vue-router";

export const createTitleGuard = (appName: string): NavigationGuard => {
  return (to) => {
    document.title =
      to.meta.title !== undefined ? `${to.meta.title} — ${appName}` : appName;
  };
};
